import { Controller } from 'react-hook-form';
import { DatePicker, Message } from '@fasstech/middle-design-system';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';
import moment from 'moment';
import { prop } from 'ramda';
import { useEffect } from 'react';

const isValidDate = (dateString) => {
  const date = moment(dateString);
  return !isNaN(date);
};

const ControlledDatePicker = ({
  name,
  form,
  rules,
  label,
  tooltip = '',
  containerClassName = '',
  className = '',
  children,
  triggerOnChange = false,
  withIndicator = true,
  isDisplayed = true,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }
  const $label = prop('required', rules) ? `${label} *` : label;

  const isDateInvalid = (date) => {
    if (!date) return !!prop('required', rules); // Champ vide : erreur seulement si required

    if (!isValidDate(date)) return true; // Format invalide

    if (extraProps.minDate && moment(date).isBefore(extraProps.minDate)) return true;

    if (extraProps.maxDate && moment(date).isAfter(extraProps.maxDate)) return true;

    return false;
  };

  return (
    <div className={`w-full md:w-[100%]! ${containerClassName}`}>
      <Controller
        name={name}
        control={form.control}
        rules={rules}
        render={(props) => {
          const value = isValidDate(props.field.value) ? props.field.value : undefined;
          const hasError = isDateInvalid(props.field.value);

          useEffect(() => {
            form.trigger(name);
            return () => {
              form.clearErrors(name);
            };
          }, [hasError]);

          return (
            <div className={`flex items-center w-full ${className}`}>
              <DatePicker
                tooltip={tooltip}
                label={$label}
                withIndicator={withIndicator}
                error={hasError}
                {...props}
                {...props.field}
                {...extraProps}
                value={value}
                selected={value}
                onChange={async (date) => {
                  props.field.onChange(date);
                  if (triggerOnChange) await form.trigger();
                }}
                locale="fr"
              />
              {children}
            </div>
          );
        }}
      />
      <Message variant="error" label={getErrorMessage(form.formState.errors, name)}/>
    </div>
  );
};

export default ControlledDatePicker;
